import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-files',
  templateUrl: './files.component.html',
  styleUrls: ['./files.component.scss'],
  standalone: false,
})
export class FilesComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
